import { useEffect, useState } from 'react';

export interface PrintConfigImage {
  figureNumber: number;
  imageUrl: string;
  custom: boolean;
}

const genericUrl = (n: number) => `/print-config-generic-${n}.png`;

// Figures 1-8 of the current tenant (its own uploads, generic ones otherwise).
export function usePrintConfigImages() {
  const [images, setImages] = useState<PrintConfigImage[]>(
    [1, 2, 3, 4, 5, 6, 7, 8].map(n => ({ figureNumber: n, imageUrl: genericUrl(n), custom: false }))
  );
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch('/api/print-configs', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled && Array.isArray(data)) setImages(data);
      } catch {
        // keep the generic figures
      }
    })();
    return () => { cancelled = true; };
  }, [version]);

  const urlFor = (n: number) => images.find(i => i.figureNumber === n)?.imageUrl ?? genericUrl(n);
  return { images, urlFor, reload: () => setVersion(v => v + 1) };
}
